const agentbanner = {
    path: 'agentbanner',
    component: resolve => require(['@/pages/admin/ad/agentbanner/index.vue'], resolve),
    meta: {
        requireAuth: true
    },
}

export default agentbanner